import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isValid", "isError", "errorMessage", "fullWidth", "label", "note", "hideNoteSpace", "onChange", "variant", "name", "commentForRating", "maxRatingText", "minRatingText"];
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Field } from '@vtblife/uikit/dist/legacy';
import React, { useMemo } from 'react';
import get from 'lodash/get';
import { Button, Group, Textarea } from '@vtblife/uikit';
import { createFormikComponent, mapFieldToInputProps } from '@vtblife/uikit-formik';
import { useFormikContext } from 'formik';
import styles from './formik-rating-field.module.css';
var FormikRatingFieldProps = function FormikRatingFieldProps(props) {
  // Skip some of params to be passed by Field to Rating
  var isValid = props.isValid,
    isError = props.isError,
    errorMessage = props.errorMessage,
    fullWidth = props.fullWidth,
    label = props.label,
    note = props.note,
    hideNoteSpace = props.hideNoteSpace,
    onChange = props.onChange,
    variant = props.variant,
    name = props.name,
    commentForRating = props.commentForRating,
    maxRatingText = props.maxRatingText,
    minRatingText = props.minRatingText,
    rest = _objectWithoutProperties(props, _excluded);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var ratingValue = get(values, "".concat(name, ".rating"));
  var commentValue = get(values, "".concat(name, ".comment")) || '';
  var items = useMemo(function () {
    var _variant$split = variant.split('-'),
      _variant$split2 = _slicedToArray(_variant$split, 2),
      min = _variant$split2[0],
      max = _variant$split2[1];
    var items = [];
    var _loop = function _loop() {
      var indexString = String(i);
      items.push(React.createElement(Button, {
        selected: indexString === ratingValue,
        variant: "secondary",
        onClick: function onClick(e) {
          setFieldValue("".concat(name, ".rating"), indexString);
        },
        key: indexString
      }, indexString));
    };
    for (var i = Number(min); i <= Number(max); i++) {
      _loop();
    }
    return items;
  }, [variant, ratingValue, setFieldValue, name]);
  return React.createElement("div", null, React.createElement("div", {
    className: styles.rating
  }, React.createElement(Group, {
    size: "l"
  }, items), React.createElement("div", {
    className: styles.ratingDescription
  }, minRatingText && React.createElement("span", {
    className: styles.minRatingText
  }, minRatingText), maxRatingText && React.createElement("span", {
    className: styles.maxRatingText
  }, maxRatingText))), (commentForRating === null || commentForRating === void 0 ? void 0 : commentForRating.includes(ratingValue)) && React.createElement("div", {
    className: styles.comment
  }, React.createElement(Textarea, {
    rows: 4,
    onChange: function onChange(value) {
      var currentValue = value.toString();
      setFieldValue("".concat(name, ".comment"), currentValue);
    },
    value: commentValue,
    size: "l",
    placeholder: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439"
  })));
};
export var RatingField = Field(FormikRatingFieldProps, false, false);
export var FormikRatingField = createFormikComponent(RatingField, mapFieldToInputProps);